import React from 'react';

import MCardExam from './MCardExam.jsx';

class Questions extends React.Component {
  constructor(props) {
    super(props);
    this.state = { questions: this.props.questions };
  }

  render() {
    let start = this.props.initialNumber - 1;

    return (
      <div className="question-wrapper">
        {this.props.questions !== undefined &&
          this.props.questions.map((question, index) => {
            start++;
            return (
              <MCardExam
                resultsSummarized={this.props.resultsSummarized}
                key={question.id}
                questionNumber={index + 1}
                {...question}
                graded={this.props.graded}
                number={start}
                updateAnswer={this.props.updateAnswer}
              />
            );
          })}
      </div>
    );
  }
}

export default Questions;
